/*
 * output will be rendered in a locale format 10000000 => 10,000,000
 */

export default value => {
  if (value == null) return 0;
  return value.toLocaleString();
};
